//Reducer Types
interface State {
  dashboardData?: any;
  dashboardMilestoneData?: any;
  milestonesCount?: any;
  financeCountData: any;
  salesDashboardData: any;
  productionDashboardData: any;
  installationDashboardData: any;
  dispatchDashboardData: any;
  customerDashboardData?: any;
  employeeAttendanceData?: any;
  printingManagerDashboardData?: any;
}

export const dashboardReducer = (
  state: State = {
    dashboardData: {},
    salesDashboardData: {},
    productionDashboardData: {},
    installationDashboardData: {},
    dispatchDashboardData: {},
    customerDashboardData: {},
    printingManagerDashboardData: {},
    employeeAttendanceData: [],
    dashboardMilestoneData: [],
    milestonesCount: 0,
    financeCountData: {
      total_received: 0,
      total_pending: 0,
      total_overdue: 0,
      accounts_approval_needed: 0,
    },
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_DASHBOARD_COUNT":
      return {
        ...state,
        dashboardData: action.payload,
      };
    case "GET_SALES_DASHBOARD_DATA":
      return {
        ...state,
        salesDashboardData: action.payload,
      };
    case "GET_FINANCE_DASHBOARD_DATA":
      return {
        ...state,
        financeCountData: action.payload,
      };
    case "GET_FINANCE_DASHBOARD_MILESTONE_DATA":
      return {
        ...state,
        dashboardMilestoneData:
          action.payload?.page == 1 || !action.payload?.page
            ? action?.payload?.data
            : [...state?.dashboardMilestoneData, ...action?.payload?.data],
        milestonesCount: action.payload?.count,
      };
    case "GET_PRODUCTION_DASHBOARD_COUNT":
      return {
        ...state,
        productionDashboardData: action.payload,
      };
    case "GET_INSTALLATION_DASHBOARD_COUNT":
      return {
        ...state,
        installationDashboardData: action.payload,
      };
    case "GET_DISPATCH_DASHBOARD_COUNT":
      return {
        ...state,
        dispatchDashboardData: action.payload,
      };
    case "GET_CUSTOMER_DASHBOARD_COUNT":
      return {
        ...state,
        customerDashboardData: action.payload,
      };
    case "GET_HR_ATTENDANCE_DATA":
      return {
        ...state,
        employeeAttendanceData: action.payload,
      };
    case "GET_PRINTING_MANAGER_DASHBOARD_DATA":
      return {
        ...state,
        printingManagerDashboardData: action.payload,
      };
    default:
      return state;
  }
};
